import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from './data.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  token: string;
  sidebarAberta = true;

  apresentarMenuLateralLogin: string = "block";

  constructor(private router: Router, public dataService: DataService) {

  }

  ngOnInit(): void {
    if (localStorage.getItem('token') == null) {
      this.router.navigate(['login']);
    }
  }

  public mostrarLoading() {
    let teste = document.getElementById('preloader');
    teste?.setAttribute("style", "display:block;");
  }

  public fecharLoading() {
    let teste = document.getElementById('preloader');
    teste?.setAttribute("style", "display:none;");
  }

  public sair() {
    localStorage.clear();
    this.dataService.usuarioLogado = '';
    this.dataService.horaExpirarToken = '';
    this.dataService.logado = false;
    this.router.navigate(['login']);
  }

  public esconderBarrar() {
    this.token == localStorage.getItem('token');
    if (this.token !== null &&
      this.token.toString().trim() !== null) {
      return false;
    } else {
      return true;
    }
  }

  toggleSidebar() {
    this.sidebarAberta = !this.sidebarAberta;

    const sidebarEl = document.querySelector('.c-sidebar');
    const wrapperEl = document.querySelector('.c-wrapper');

    if (sidebarEl && wrapperEl) {
      if (this.sidebarAberta) {
        sidebarEl.classList.remove('c-sidebar-minimized');
        wrapperEl.classList.remove('sidebar-minimized');
      } else {
        sidebarEl.classList.add('c-sidebar-minimized');
        wrapperEl.classList.add('sidebar-minimized');
      }
    }
  }

}
